export const MAX_PRODUCTS_PER_COLLECTION_FOR_GUIDANCE = 100;

export enum GuidanceSourceType {
  PRODUCTS = "products",
  SHOPIFY_COLLECTION = "shopify_collection",
}
